<template>
  <v-container fluid>

    <span>{{ $t('app.uploads.clickBelowToUpload') }}</span>
    <div class="img-border">
      <div class="img-container">
        <Upload
          @fileSelect="handleFile"
          ref="fileInputProfile"
          hidden
          :label="$t('general.post.upload')"
        />

        <img
          v-if="!nurse.upload || !nurse.upload.blobUri"
          id="upload-image"
          class="profile-picture"
          src="@/assets/images/nophoto.png"
          :alt="
            `Profile picture of ${nurse.nickName}`
          "
          @click="selectProfilePicture"
        />
        <!-- Auto rotate -->
        <auto-rotate v-else>
          <img
            id="upload-image"
            class="profile-picture"
            :src="nurse.upload.blobUri"
            :alt="
              `Profile picture of ${nurse.nickName}`
            "
            @click="

                $modal.show('profile-pic-menu-modal')
            "
          />
        </auto-rotate>
        <p style="color:red" v-if="error">{{ error }}</p>

        <modal
          class="menu"
          name="profile-pic-menu-modal"
          width="100%"
          height="auto"
        >
          <ListItem
            border="1px solid #31b9be"
            @click.native="selectProfilePicture"
          >{{ $t("app.picture.edit") }}</ListItem
          >
          <ListItem
            border="1px solid #31b9be"
            last="true"
            @click.native="deleteProfilePicture"
          >{{ $t("app.picture.delete") }}</ListItem
          >
        </modal>
      </div>
      <span
        :style="
          `background-image: url(${require(`@/assets/icons/heart-pink.svg`)})`
        "
        class="mark"
      ></span>
    </div>

    <div>
      <div class="error" v-if="error">
        <p>{{ error }}</p>
      </div>

      <div class="field">
<!--
        <img
          v-if="nurse && nurse.uploadId"
          id="img-preview"
          :src="this.nurse.upload.blobUri"
          :alt="`Profile picture of ${nurse.firstName}`"
          @click="selectImage"
        />
        <img
          v-else
          id="img-preview"
          src="@/assets/images/nophoto.png"
          @click="selectImage"
        />
        <Upload ref="fileInput" class="hidden" v-on:fileSelect="fileSelect" />
-->

        <InputField
          v-model="form.email"
          :labelTitle="$t('dash.nurse.form-email')"
          required
          placeholder="email@email.com"
          margin="0 auto 25px auto"
          ref="name"
        ></InputField>

        <InputField
          v-model="form.firstName"
          :labelTitle="$t('dash.nurse.form-firstname')"
          :placeholder="$t('dash.nurse.form-firstname')"
          margin="0 auto 25px auto"
          ref="name"
        ></InputField>

        <InputField
          v-model="form.lastName"
          :labelTitle="$t('dash.nurse.form-lastname')"
          :placeholder="$t('dash.nurse.form-lastname')"
          margin="0 auto 25px auto"
        ></InputField>

        <InputField
          v-model="form.nickName"
          :labelTitle="$t('dash.nurse.form-nickname')"
          :placeholder="$t('dash.nurse.form-nickname')"
          margin="0 auto 25px auto"
          required
        ></InputField>

        <InputField
          v-model="form.phone"
          :labelTitle="$t('app.temp-home.phone')"
          :placeholder="$t('app.temp-home.phone')"
          margin="0 auto 25px auto"
        ></InputField>

        <TextAreaField
          v-model="form.bio"
          :labelTitle="$t('dash.nurse.form-bio')"
          :placeholder="$t('dash.nurse.form-bio-placeholder')"
          :rows="3"
        ></TextAreaField>

        <v-checkbox
          v-if="this.nurse.id !== this.$store.getters.user.id"
          input-value="false"
          v-model="form.isAdmin"
          class="ml-16"
          :label="$t('dash.nurse.isAdmin')"
        ></v-checkbox>

        <LoadingButton v-if="loading"></LoadingButton>
        <div v-else>
          <p class="red" v-if="requiredNeededError">{{ $t('dash.nurse.requiredNeededError') }}</p>

          <Button
            v-if="editId"
            width="200"
            :title="$t('dash.nurse.action-save')"
            style="margin: 16px 0"
            @click.native="writeNurse('edit')"
          ></Button>
          <Button
            v-if="!editId"
            width="200"
            :title="$t('dash.nurse.action-add')"
            style="margin: 16px 0"
            @click.native="writeNurse('add')"
          ></Button>
          <Button
            v-if="editId && !this.nurse.hasExternalId"
            width="200"
            :title="$t('dash.nurse.sendInviteAgain')"
            style="margin: 16px 0"
            class="ml-3"
            @click.native="sendInvite()"
          ></Button>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import {neoparentNurses, neoparentUploads, neoparentUsers} from "@/api";
import { setImgPreview, uploadFile } from "@/helpers";
import Vue from "vue";
import i18n from "@/services/i18n";

export default {
  name: "neoparent-create-nurse",
  data() {
    return {
      error: "",
      form: {
        email: "",
        firstName: "",
        lastName: "",
        nickName: "",
        bio: "",
        isAdmin: "",
        phone: ""
      },
      requiredNeededError: false,
      editId: new URL(window.location).searchParams.get("nurseId"),
      nurse: {},
      loading: false,
      inviteSuccessful: false
    };
  },
  computed: {
    canSave: function () {
      if (!this.form.email)
        return false
      if (!this.form.nickName)
        return false
      return true
    }
  },
  mounted() {
    // Focus input field
    this.$refs.name.$el.children[1].focus();
    if (this.editId) {
      neoparentNurses
        .getNurse(this.editId)
        .then(result => {
          this.consoleLog(result);
          this.nurse = result.data.nurse;
          this.form.email = this.nurse.email;
          this.form.firstName = this.nurse.firstName;
          this.form.lastName = this.nurse.lastName;
          this.form.nickName = this.nurse.nickName;
          this.form.bio = this.nurse.bio;
          this.form.phone = this.nurse.phone;
          this.form.isAdmin = this.nurse.role === 'a'
        })
        .catch(err => {
          this.consoleLog(err);
        });
    }
  },
  methods: {
    deleteProfilePicture(){
      this.nurse.upload = null
      this.nurse.uploadId = null
      this.$modal.hide("profile-pic-menu-modal");
    },
    async handleFile(files) {
        let file = files[0];
      if (file) {
        const formData = new FormData()
        formData.append("file", file, file.name)
        formData.append("access", file.access)
        formData.append("mimeType", file.type)
        formData.append("isProfilePicture", true)

        const res = await neoparentUploads.uploadFile(formData)

        if (Object.keys(this.nurse).length === 0){
          this.nurse = { upload: res.data.data }
        } else {
          this.nurse.upload = res.data.data
        }
      }
    },
    selectProfilePicture() {
      console.log("Selected")
      this.$modal.hide("profile-pic-menu-modal");
      this.$refs.fileInputProfile.$el.click();
    },

    selectImage() {
      this.consoleLog(this.$refs);
    },
    async writeNurse(action) {
      if (action !== "add" && action !== "edit") return;
      if (!this.canSave){
        this.requiredNeededError = true;
        return;
      }
      this.loading = true;

       let imageId = null;

      const data = {
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        nickName: this.form.nickName,
        bio: this.form.bio,
        hospitalId: this.$store.getters.user.hospital.id,
        uploadId: this.nurse.upload ? this.nurse.upload.id : null,
        email: this.form.email,
        phone: this.form.phone,
        role: this.form.isAdmin ? 'a' : 'n'
      };
      this.consoleLog(data);

      if (action === "add") {
        // Create new
        this.consoleLog("Creating nurse");
        neoparentUsers
          .addUser(data)
          .then(result => {
            this.loading = false;
            this.consoleLog(result);
            window.location.href = "/dashboard/nurses";
          })
          .catch(err => {
            this.loading = false;
            this.error = err.response.data.message;
            window.scrollTo(0, 0);
            this.consoleLog(err);
          });
      } else {
        // Edit nurse
        this.consoleLog("Updating nurse");
        data.id = this.editId;
        neoparentNurses
          .editNurse(this.editId, data)
          .then(result => {
            this.loading = false;
            this.consoleLog(result);
            window.location.href = "/dashboard/nurses";
          })
          .catch(err => {
            this.loading = false;
            this.error = err.response.data.message;
            window.scrollTo(0, 0);
            this.consoleLog(err);
          });
      }
    },
    async sendInvite() {
      const that = this;
      const data = {
        id: this.editId,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        nickName: this.form.nickName,
        bio: this.form.bio,
        hospitalId: this.$store.getters.user.hospital.id,
        email: this.form.email,
        role: this.form.isAdmin ? 'a' : 'n'
      };

      await neoparentUsers.sendInvite(data).then(() => {
        Vue.$toast.open({
          type: 'success',
          // Use the correct toast language
          message:  i18n.getLocaleMessage(i18n.locale)['dash']['nurse']['inviteSent'],
          position: 'bottom',
          duration: 10000,
        });
      })
    }
  }
};
</script>

<style scoped lang="scss">
.loggedin-notice {
  color: #979797;
}

.img-border {
  width: 200px;
  background: #d9f0ea;
  border-radius: 5px;
  height: 200px;
  overflow: hidden;
  margin: 24px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.img-container {
  overflow: hidden;
  border-radius: 50%;
  width: 75%;
  height: 75%;
  margin: auto;
}

.img-border img {
  width: 100%;
  height: 100%;
}

input {
  display: none;
}

label {
  cursor: pointer;
}

.mark {
  background-color: transparent;
  background-size: 100%;
  width: 56px;
  height: 56px;
  padding: 0;
  position: absolute;
  bottom: 0;
  right: 0;
}

.profile-menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

/* -webkit-overflow-scrolling only exists for ios */
@supports (-webkit-overflow-scrolling: touch) {
  .profile-menu {
    justify-content: space-around; /* space-evenly doesn't work on ios */
  }
}

.profile-picture {
  object-fit: cover;
}

#img-preview {
  margin: 25px auto;
  width: 200px;
  max-height: 200px;
  border: 1px solid #e05484;
}
</style>
